import React, { useState } from 'react';
import { toast } from 'sonner';
import { useT } from '../../i18n';
import { authFetch } from '../../lib/auth';
import { useOs2, PageHead, Card } from './os2ui';

export function SettingsOsPage() {
  const { lang } = useT();
  const isEs = lang === 'es';
  const { data: hdr, reload } = useOs2('/header');
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await authFetch('/os2/profile', {
        method: 'PUT',
        body: JSON.stringify({ ...(name && { name }), ...(city && { city }) }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      await reload();
      toast.success(isEs ? 'Perfil actualizado ✓' : 'Profile updated ✓');
    } catch (e) {
      toast.error(String(e.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="os2-settings">
      <PageHead
        title={isEs ? 'Perfil / Ajustes' : 'Profile / Settings'}
        question={isEs ? 'Tu identidad y contexto dentro del AI OS.' : 'Your identity and context inside the AI OS.'}
      />
      <Card className="p-6 max-w-lg">
        <div className="space-y-4">
          <div>
            <label className="text-[12px] font-medium text-gray-500">{isEs ? 'Nombre (saludo)' : 'Name (greeting)'}</label>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder={hdr?.name || 'Oscar'}
              className="mt-1 w-full h-10 px-3 rounded-lg border border-gray-200 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#F77F11]/40"
              data-testid="settings-name" />
          </div>
          <div>
            <label className="text-[12px] font-medium text-gray-500">{isEs ? 'Ciudad (para el clima)' : 'City (for weather)'}</label>
            <input value={city} onChange={(e) => setCity(e.target.value)} placeholder={hdr?.city || 'Knoxville'}
              className="mt-1 w-full h-10 px-3 rounded-lg border border-gray-200 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#F77F11]/40"
              data-testid="settings-city" />
          </div>
          <button onClick={save} disabled={busy || (!name && !city)}
            className="inline-flex items-center rounded-full bg-[#F77F11] hover:bg-[#d8651a] disabled:opacity-40 text-white text-[13px] font-semibold px-5 py-2.5 transition-colors"
            data-testid="settings-save">
            {busy ? '…' : (isEs ? 'Guardar' : 'Save')}
          </button>
        </div>
      </Card>
    </div>
  );
}
